<template>
    <div class="question-section">
        <div class="question-section__row">
            <h2 class="question-section__heading">{{ heading }}</h2>
            <hr class="question-section__divider">
        </div>
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "QuestionSection",
        props: ['heading']
    }
</script>

<style lang="scss" scoped>

    .heading-flex {
        flex: 0 1 auto;
        padding-right: 20px;
    }
    .question-section {
        margin-bottom: 2rem;
    }

    .question-section__row {
        display: flex;
        margin-bottom: 1rem;
    }

    .question-section__heading {
        flex: 0 1 auto;
        padding-right: 20px;
        height: 17px;
        opacity: 0.8;
        color: #5B6786;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
    }

    .question-section__divider {
        flex: 1;
        margin-top: .5rem;
        margin-bottom: .5rem;
    }
</style>
